import { render } from "./CandidatInfo.vue?vue&type=template&id=489ec058"
import script from "./CandidatInfo.vue?vue&type=script&lang=js"
export * from "./CandidatInfo.vue?vue&type=script&lang=js"

import "./CandidatInfo.vue?vue&type=style&index=0&id=489ec058&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__